<template>
  <div class="standard-arrow-navigation" :class="[{'standard-arrow-navigation--external-header': externalHeadersVisible}]">
      <div class="standard-arrow-navigation-labels">
          <p v-show="this.displayName" class="standard-arrow-navigation-labels-numbers">
            {{ currentComponentNumber }} / {{ visibleComponentsNumber }}
          </p>
          <h2 :class="['standard-arrow-navigation-labels-component-name', {'extra-margin': !this.displayName}]" >
            <span id="customs-component-navigation">
              {{ this.displayName  || this.optionalDisplayName}}
            </span>
          </h2>
      </div>
      <div class="standard-arrow-navigation-steps">
          <button
            @click="changeComponent('previous')"
            aria-label="previous"
            class=
              'standard-arrow-navigation-steps-open-prev standard-arrow-navigation-button'
          >
              <span class="standard-arrow-navigation-button-icon icon-arrow-left-indicator"></span>
          </button>
          <button
            @click="changeComponent()"
            aria-label="next"
            class=
              'standard-arrow-navigation-steps-open-next standard-arrow-navigation-button'
            >
              <span class="standard-arrow-navigation-button-icon icon-arrow-right-indicator"></span>
          </button>
      </div>
    </div>
</template>

<script>
import mixins from 'vue-typed-mixins';
import StandardNavigationMixin from "@/mixins/Customizer/StandardNavigation";
export default mixins(StandardNavigationMixin).extend({
  name: "StandardArrowNavigation",
  data(){
    return {
      items: [],
    }
  },
  computed: {
    activeComponent() {
      const isApparel = this.$store.getters['utils/isApparelEnabled'];
      if (isApparel){
        return this.$store.state.standardNavigation.activeSubComponent !== '' ?
        `${this.$store.state.standardNavigation.activeComponent}/${this.$store.state.standardNavigation.activeSubComponent}`:
          this.$store.state.standardNavigation.activeComponent;
      }
      else {
        return this.$store.state.legacyNavigation.activeComponent;
      }
    },
    menu() {
      return this.$store.state.standardNavigation.menu;
    },
    getItemsId() {
      let items = []
      const tmpItems = this.$store.state.standardNavigation.menu.filter((item)=>{ return item.visible === true; });
      if(tmpItems){
        for(let topLevelItem in tmpItems){
          items.push(tmpItems[topLevelItem].id)
          if(tmpItems[topLevelItem].children) {
            tmpItems[topLevelItem].children.forEach(item => items.push(`${tmpItems[topLevelItem].id}/${item.id}`))
          }
        }
      }
      return items;
    },
    currentComponentNumber() {
      let currentPosition = this.getItemsId.indexOf(this.activeComponent) + 1
      return currentPosition
    },
    visibleComponentsNumber() {
      return this.getItemsId.length
    },
    displayName(){
      let name = ''
      const components = this.activeComponent.split('/')
      const component = components[0]
      const subcomponent = components[1] ?? ""
      if(this.menu.length > 0){
        for(let item in this.menu){
          if(this.menu[item].id === component && subcomponent === "") {
            name = this.menu[item].name
            break
          } else if (this.menu[item].id === component && this.menu[item].children) {
            for(let subitem in this.menu[item].children){
              if(this.menu[item].children[subitem].id === subcomponent) {
                name = this.menu[item].children[subitem].name
                break
              }
            }
          }
        }
      }
      return name;
    },
    optionalDisplayName() {
      const optionalDisplayName =  this.$store.state.swatches?.tabsSwatches[this.activeComponent]?.[this.activeComponent]?.display_name
      return optionalDisplayName
    },
    isSplashModalOpen() {
      return this.$store.state.utils.isSplashModalOpen;
    },
    externalHeadersVisible() {
      return this.$store.state.utils.externalHeadersVisible && !this.$store.getters['utils/regionIsApac'];
    },
  },
  methods:{
    closeSplashPage(){
      this.$eventBus.$emit('splash-page-background-click');
    },
    changeComponent(action){
      if(this.isSplashModalOpen) {
        this.closeSplashPage();
        return;
      }
      let currentItem = this.getItemsId.indexOf(this.activeComponent)
      let activeItem
      if(action === 'previous') {
        if(this.currentComponentNumber > 1){
          currentItem --
          activeItem = this.getItemsId[currentItem]
        }
        else if(this.currentComponentNumber === 1 || !this.displayName){
          currentItem = this.visibleComponentsNumber - 1
          activeItem = this.getItemsId[currentItem]
        }
      }
      if(action !== 'previous'){
        if(this.currentComponentNumber < this.visibleComponentsNumber){
          currentItem ++
          activeItem = this.getItemsId[currentItem]
        }
        else if(this.currentComponentNumber  === (this.visibleComponentsNumber)){
          currentItem = 0
          activeItem = this.getItemsId[currentItem]
        }
      }
      this.$eventBus.$emit("select-component", activeItem, this.$customizerDataLayer.types.selectComponentArrow, true, "", true, true, true)
    },
  },
})
</script>